import {useStore} from "vuex";
import {computed} from "vue";

export default function UseCrudElements() {

  const store = useStore()
  store.dispatch('elements/loadElementsData')

  const searchValue = computed({
    get: () => store.state.elements.searchItems.searchHouseElement,
    set: newVal => store.commit('elements/setSearchHouseElement', newVal)
  })

  return {
    isHouseElementsLoading: computed(() => store.state.elements.loadStatuses.isHouseElementsLoading),
    isDeleteElementLoading: computed(() => store.state.elements.loadStatuses.isDeleteElementLoading),
    commonElements: computed(() => store.state.elements.common.elements),
    commonCategories: computed(() => store.state.elements.common.categories),

    getCurrentHouseElements: computed(() => store.getters['elements/getCurrentHouseElements']),
    setSelectedElement: elementId => store.commit('elements/setSelectedElement', elementId),
    deleteElement: () => store.dispatch('elements/deleteElement'),
    searchValue
  }
}
